export const SpecialDailyOffer = (json: ISpecialDailyOffers): ISpecialDailyOffersModel => {
	const fromJSON = (json: ISpecialDailyOffers) => {
		const { product_id, product, discount_percentage, created_at, updated_at, ...rest } = json

		return {
			...rest,
			productId: product_id,
			product: Product(product),
			discountPercentage: discount_percentage,
			createdAt: created_at,
			updatedAt: updated_at,
		}
	}

	return { ...fromJSON(json) }
}
